import React from "react"
import { ExpandableSection, Icon, Typography, icons, theme } from "cdh-data-portal-theme"
import { StatCard } from "../../atoms/StatCard/StatCard"
import { useLandingPage } from "./LandingPage.logic"
import { useStyles } from "./LandingPage.style"
import { RESOURCE_LINKS, localtext } from "./LandingPage.static"

export const LandingPage: React.FC = () => {
  const { classes } = useStyles()
  const { totalOperations } = useLandingPage()

  return (
    <div className={classes.root}>
      <Typography variant="headline1" className={classes.title} color={theme.textColors.primary}>{localtext.Title}</Typography>
      <Typography variant="body" className={classes.subtitle} color={theme.textColors.primaryLighter}>{localtext.Welcome}</Typography>
      <div className={classes.cards}>
        <StatCard color={theme.colors.warning} count={localtext.DefaultCount} title={localtext.PendingRequests} />
        <StatCard
          color={theme.colors.primary}
          count={totalOperations === null ? localtext.DefaultCount : String(totalOperations)}
          title={localtext.TotalOperations}
        />
      </div>
      <ExpandableSection title={localtext.Resources} titleVariant="body2" className={classes.expandableSection} initiallyExpanded>
        {RESOURCE_LINKS.map(link => (
          <a
            key={link.title}
            href={link.url}
            target="_blank"
            rel="noreferrer"
            className={classes.resourceRow}
          >
            <Icon iconPath={icons[link.iconKey as keyof typeof icons]} color={theme.textColors.primaryLight} />
            <div className={classes.resourceContent}>
              <Typography variant="headline3" className={classes.resourceLinkTitle}>{link.title}</Typography>
              <Typography variant="label1" className={classes.resourceDescription} color={theme.textColors.primaryLight}>{link.description}</Typography>
            </div>
          </a>
        ))}
      </ExpandableSection>
    </div>
  )
}
